import React, { useEffect, useState } from 'react';
import ListTemplate from '../../../Reusable_Components/ListTemplate'; 
import axios from 'axios';
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/apiConfig'; 

const AccountListDetails = () => {
  const [accounts, setAccounts] = useState([]);

  useEffect(() => {
    const fetchAccounts = async () => {
      try {
        const url = `${API_DOMAIN}${API_ROUTES.account}`;

        const token = localStorage.getItem('token');
        
        const response = await axios.get(url, { headers });

        // response.data.forEach((account) => {
        //     account.balance = hash(account.balance);
        // });

        // const hash = (value) => {
        //   const hash = crypto.createHash('sha256');
        //   hash.update(String(value));
        //   return hash.digest('hex');
        // };

        setAccounts(response.data);
      } catch (error) {
        console.error('Error fetching accounts:', error);
      }
    };

    fetchAccounts();
  }, []);

  const columns = [
    { label: 'Account Name', value: 'name' },
    { label: 'Account Code', value: 'code' },
    { label: 'Account Type', value: 'account_type' },
    // { label: 'Parent Account', value: (account) => account.parent_account?.name || 'None' },
    // { label: 'Balance', value: 'balance' },

    
  ];

  const handleViewDetails = (accountId) => {
    const encodedId = btoa(accountId);
    window.location.href = `/account/details/${encodedId}`;
  };

  const actionButtons = [
    { label: 'View Details', handler: handleViewDetails },
  ];

  return <ListTemplate columns={columns} data={accounts} actionButtons={actionButtons} />;
};

export default AccountListDetails;